import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  // Radio as ChakraRadio,
  // RadioGroup,
  Button as ChakraButton,
  Container,
  // OrderedList,
  // ListItem,
  FormControl,
  FormHelperText,
  Heading,
  Stack,
  Text,
  useDisclosure,
  // HStack,
  // VStack,
  // CircularProgress,
  useToast,
} from "@chakra-ui/react";
import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
// components
import Header from "components/dashHeader";
import Input from "components/Input/Input";
import Select from "components/Select/Select";
import Sidemenu from "components/sidemenu";
// import format from "date-fns/format";
import toLower from "lodash/toLower";
import "pages/styles/dashboard/Account.css";
// import { selectProfile } from "store/slices/profile.slice";
// import Uploader from "components/Uploader/Uploader";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  clearError,
  resetLevel2Form,
  selectAccountVerification,
  updateLevel2Form,
} from "store/slices/accountVerification.slice";
import { calculateAge } from "util/utils";
// import { uploadFile } from "util/do";
import UploadSuccessModal from "./Modals/UploadSuccess";

// const Radio = ({ value, children }) => {
//   return (
//     <ChakraRadio
//       className="customChakraRadio"
//       colorScheme="green"
//       value={value}
//       bg="#D6D8E7"
//       border="none"
//       _focus={{
//         boxShadow: "0 0 0 3px #06C3448f",
//       }}
//     >
//       {children}
//     </ChakraRadio>
//   );
// };

const Button = ({ outlined, children, disabled, ...rest }) => {
  return (
    <ChakraButton
      minW="150px"
      borderRadius="50px"
      color={outlined ? "#03A438" : "white"}
      bg={outlined ? "white" : "#03A438"}
      border={outlined ? "2px solid #03A438" : "none"}
      textTransform="capitalize"
      transition="all 300ms ease-in-out"
      p="10px 20px"
      disabled={disabled}
      _hover={{
        cursor: disabled ? "not-allowed !important" : "pointer",
        boxShadow: "0 0 0 3px #06C3448f, 0 0 10px rgba(0,0,0,.05)",
        transition: "all 300ms ease-in-out",
      }}
      _focus={{
        boxShadow: "0 0 0 3px #06C3448f, 0 0 10px rgba(0,0,0,.05)",
        transition: "all 300ms ease-in-out",
      }}
      _disabled={{
        opacity: 0.4,
        pointerEvents: "none",
      }}
      {...rest}
    >
      {children}
    </ChakraButton>
  );
};

// const StepOne = ({ onFileChange, email }) => {
//   return (
//     <Box mt="28px">
//       <Stack color="#4E4B66">
//         <Text fontSize=".9em" fontWeight="500">
//           Step 1:
//         </Text>
//         <Text fontSize=".8em" fontWeight="400">
//           Place ID card on a piece of paper with this inscription
//         </Text>
//       </Stack>

//       <OrderedList
//         m="0"
//         mt="10px"
//         fontSize=".8em"
//         fontWeight="400"
//         color="#4E4B66"
//       >
//         <ListItem>
//           Bitmama verification - {email} - {format(new Date(), "dd/MM/yy")}
//         </ListItem>
//         {/* <ListItem>2. Email</ListItem>
//         <ListItem>3. Date</ListItem> */}
//       </OrderedList>

//       <VStack
//         justify="center"
//         w="100%"
//         p={["26px 0", "26px 0", "26px"]}
//         gridGap="12px"
//       >
//         <Uploader
//           // files={[selectedFile].filter(Boolean)}
//           onFiles={(files) =>
//             onFileChange({ file: files[0], type: "document" })
//           }
//         />
//         <Text m="0 !important" color="#4E4B66" fontSize=".8em">
//           Upload .PDF/.JPG/.JPEG/.PNG file and no more than 5M
//         </Text>
//       </VStack>
//     </Box>
//   );
// };

// const StepTwo = ({ onFileChange }) => {
//   return (
//     <Box mt="28px">
//       <Stack color="#4E4B66">
//         <Text fontSize=".9em" fontWeight="500">
//           Step 2:
//         </Text>
//         <Text fontSize=".8em" fontWeight="400">
//           Hold ID card close to your face, snap and upload image
//         </Text>
//       </Stack>
//       <VStack
//         justify="center"
//         w="100%"
//         p={["26px 0", "26px 0", "26px"]}
//         gridGap="12px"
//       >
//         <Uploader
//           onFiles={(files) => onFileChange({ file: files[0], type: "selfie" })}
//         />
//         <Text m="0 !important" color="#4E4B66" fontSize=".8em">
//           Upload .PDF/.JPG/.JPEG/.PNG file and no more than 5M
//         </Text>
//       </VStack>
//     </Box>
//   );
// };

const AccountLevel2Verification = (props) => {
  const toast = useToast();
  const { isOpen, onClose, onOpen } = useDisclosure();
  // const [isUploading, setIsUploading] = useState(false);

  // const [stepOneFile, setStepOneFile] = useState();
  // const [stepTwoFile, setStepTwoFile] = useState();

  const userData = props.userData;

  const {
    error,
    level2: { status, docType, category, nameOnId, ninNumber, dateOfBirth },
  } = useSelector(selectAccountVerification);
  const dispatch = useDispatch();
  const history = useHistory();

  // const {
  //   profile: { country: profileCountry },
  // } = useSelector(selectProfile);

  // const country = userData?.country;

  const IDMap = {
    primary: [
      { name: "National ID", value: "national_id", category: "primary" },
      { name: "Voter's Card", value: "voters_card", category: "primary" },
      {
        name: "KRA Certificate",
        value: "kra_certificate",
        category: "primary",
      },
      {
        name: "Driver's License",
        value: "driver_licence",
        category: "primary",
      },
      {
        name: "International Passport",
        value: "international_passport",
        category: "primary",
      },
      {
        name: "NIMC SLIP",
        value: "nimc_slip",
        category: "primary",
      },
      {
        name: "Birth Certificate",
        value: "birth_certificate",
        category: "primary", // only for kenya users
      },
    ],
    secondary: [
      { name: "Work ID", value: "work_id", category: "secondary" },
      { name: "Tax Card", value: "tax_card", category: "secondary" },
      {
        name: "Bank Statement",
        value: "bank_statement",
        category: "secondary",
      },
      {
        name: "School ID Card",
        value: "school_id_card",
        category: "secondary",
      },
      {
        name: "Court Affidavit",
        value: "court_affidavit",
        category: "secondary",
      },
      {
        name: "Birth Certificate",
        value: "birth_certificate",
        category: "secondary",
      },
      {
        name: "Marriage Certificate",
        value: "marriage_certificate",
        category: "secondary",
      },
    ],
  };

  const idTypes = useMemo(() => {
    const map = {
      nigeria: [
        ...IDMap.primary.filter(
          (d) => !["kra_certificate", "birth_certificate"].includes(d.value)
        ),
        // ...IDMap.secondary,
      ],
      ghana: IDMap.primary.filter(
        (d) => !["kra_certificate", "birth_certificate"].includes(d.value)
      ),
      kenya: IDMap.primary.filter((d) =>
        [
          "national_id",
          "international_passport",
          "kra_certificate",
          "birth_certificate",
        ].includes(d.value)
      ),
    };

    return map[toLower(userData?.country)] || map["nigeria"];

    // eslint-disable-next-line
  }, [userData]);

  useEffect(() => {
    if (error.message) {
      toast({
        position: "bottom-right",
        title: "Oops an error occurred",
        description: error.message,
        status: "error",
        duration: 9000,
        isClosable: true,
        onCloseComplete: () => {
          dispatch(clearError());
        },
      });
    }
  }, [error?.message, dispatch, toast]);

  useEffect(() => {
    if (status === "success") {
      onOpen();
    }
  }, [status, onOpen]);

  const handleState = (newState) => {
    dispatch(updateLevel2Form({ ...newState }));
  };

  const handleIdTypeChange = (e) => {
    const [category, docType] = String(e.target.value).split("-");

    console.log("DOC TYPE", category, docType);
    // dispatch(updateLevel2Form({ category, docType }));
    handleState({ category, docType });
  };

  const handleUpload = async () => {
    // if (String(country).toLowerCase() === "nigeria")
    history.push("/dashboard/account/verification/level2-upload");
    // if (String(country).toLowerCase() === "ghana") {
    //   if (!stepOneFile && !stepTwoFile) return;
    //   setIsUploading(true);
    //   const toUpload = [];
    //   [stepOneFile, stepTwoFile].forEach((doc) => {
    //     const filename = `idDoc_${category}_${doc.type}_${userData.userId}`;
    //     toUpload.push(uploadFile(doc.file, filename));
    //   });
    //   const res = await Promise.all(toUpload);
    //   const endRes = res.filter(Boolean);
    //   console.log("UPLOADED FILES", endRes);

    //   if (endRes[0] && endRes[1]) {
    //     dispatch(
    //       updateLevel2Form({
    //         docLink: endRes[0].location,
    //         individualLink: endRes[1].location,
    //         kycLevel: "two",
    //       })
    //     );
    //   }

    //   dispatch(uploadLevel2Docs());
    //   setIsUploading(false);
    // }
  };

  // const handlePrimaryUpload = async () => {
  // if (endRes[0] && endRes[1]) {
  //   dispatch(
  //     updateLevel2Form({
  //       docLink: endRes[0].location,
  //       individualLink: endRes[1].location,
  //     })
  //   );
  // }

  //   dispatch(uploadLevel2Docs());
  // };

  // const isDisabled = (country) => {
  //   if (String(country).toLowerCase() === "nigeria")
  //     return !(docType && category);
  //   if (String(country).toLowerCase() === "ghana")
  //     return !(docType && category && stepOneFile && stepTwoFile);
  // };

  console.log("AGE", calculateAge(new Date(dateOfBirth)));

  const age = useMemo(
    () => dateOfBirth && calculateAge(new Date(dateOfBirth)),
    [dateOfBirth]
  );

  const isAgeInavid = useMemo(() => age < 18 || age > 70, [age]);

  const isExpirable = useMemo(
    () => ["international_passport", "driver_licence"].includes(docType),
    [docType]
  );

  const isDisabled = useMemo(
    () =>
      !(docType && category && nameOnId && ninNumber && dateOfBirth) ||
      isAgeInavid,
    [docType, category, nameOnId, ninNumber, dateOfBirth, isAgeInavid]
  );

  return (
    <Box>
      <Sidemenu currentPage="Account" logoutUser={props.logout} />
      <Header />

      <Box as="section">
        <Box
          className="account-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container
            maxW={["100%", "100%", "calc(100% - 15vw)", "calc(100% - 30vw)"]}
            m="0"
            p={[0, 0, "1rem"]}
          >
            <Stack mx={["24px", 0]}>
              <Heading fontSize="3xl">Verification</Heading>
              <Breadcrumb
                className="animate__animated animate__fadeInDown"
                separator={
                  <ArrowForwardIosRoundedIcon
                    style={{ fontSize: ".8em", color: "#6E7191" }}
                  />
                }
              >
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/account">
                    Account
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/account/verification">
                    Verification
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem isCurrentPage pointerEvents="none">
                  <BreadcrumbLink isCurrentPage to="">
                    Level 2
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Stack>

            <Box
              bg="white"
              p={["32px 24px", "45px 40px"]}
              mt={["24px", "50px"]}
              borderRadius={[0, "8px", "16px"]}
            >
              <Stack gridGap="10px">
                <Heading color="#14142B" fontSize="1.3em">
                  Level 2 Verification
                </Heading>
                <Text color="#4E4B66" fontSize=".9em" m="0 !important">
                  Please provide the information required to continue with your
                  account upgrade.
                </Text>
              </Stack>

              {/* <Box mt="50px" mb={["50px", 0]}>
                <RadioGroup
                  name="documentType"
                  value={`${category}-${docType}`}
                  onChange={handleIdTypeChange}
                >
                  <Stack direction={["column-reverse", "row"]} gridGap="32px">
                    {String(country).toLowerCase() === "nigeria" && (
                      <Stack direction="column">
                        {IDMap.secondary.map((type) => (
                          <Radio
                            key={type.value}
                            colorScheme="green"
                            value={`secondary-${type.value}`}
                          >
                            {type.name}
                          </Radio>
                        ))}
                      </Stack>
                    )}
                    <Stack direction="column">
                      {IDMap.primary.map((type) => (
                        <Radio
                          key={type.value}
                          colorScheme="green"
                          value={`primary-${type.value}`}
                        >
                          {type.name}
                        </Radio>
                      ))}
                    </Stack>
                  </Stack>
                </RadioGroup>
              </Box> */}

              {/* {String(country).toLowerCase() !== "nigeria" && (
                <Box>
                  <StepOne
                    email={userData?.email ?? ""}
                    onFileChange={(file) => setStepOneFile(file)}
                  />
                  <StepTwo onFileChange={(file) => setStepTwoFile(file)} />
                </Box>
              )} */}

              {/* <HStack
                w="100%"
                justify="center"
                p={["20px", "60px"]}
                gridGap="20px"
              >
                <Button onClick={() => history.goBack()} outlined>
                  Back
                </Button>
                <Button disabled={isDisabled(country)} onClick={handleUpload}>
                  {(isUploading || status === "loading") && (
                    <CircularProgress
                      size="18px"
                      isIndeterminate
                      color="green.300"
                    />
                  )}
                  {!isUploading &&
                    status !== "loading" &&
                    String(country).toLowerCase() !== "nigeria" &&
                    "Upload"}
                  {!isUploading &&
                    status !== "loading" &&
                    String(country).toLowerCase() !== "ghana" &&
                    "Continue"}
                </Button>
              </HStack> */}

              <Box as="form" mt="20px" maxW="70%">
                <FormControl>
                  <Select
                    label="ID Type"
                    placeholder="Select ID Type"
                    value={`${category}-${docType}`}
                    onChange={handleIdTypeChange}
                  >
                    {idTypes?.map((type) => (
                      <option
                        value={`${type.category}-${type.value}`}
                        key={`id-type-${type.value}`}
                      >
                        {type.name}
                      </option>
                    ))}
                  </Select>

                  {isExpirable && (
                    <FormHelperText>
                      Note: ID should be at least 6 months from expiration
                    </FormHelperText>
                  )}
                </FormControl>
                <FormControl mt="10px !important">
                  <Input
                    label="Name on ID"
                    placeholder="Enter name"
                    name="name"
                    value={nameOnId}
                    onChange={(e) => handleState({ nameOnId: e.target.value })}
                  />
                </FormControl>
                {docType !== "kra_certificate" && (
                  <FormControl mt="10px !important">
                    <Input
                      type="text"
                      label="ID card number"
                      placeholder="Enter ID card number"
                      name="cardNumber"
                      value={ninNumber ?? ""}
                      onChange={(e) =>
                        handleState({ ninNumber: e.target.value })
                      }
                    />
                  </FormControl>
                )}
                {userData?.country === "kenya" &&
                  docType === "kra_certificate" && (
                    <FormControl mt="10px !important">
                      <Input
                        type="text"
                        label="KRA Pin"
                        placeholder="Enter kra pin"
                        name="cardNumber"
                        value={ninNumber ?? ""}
                        onChange={(e) =>
                          handleState({ ninNumber: e.target.value })
                        }
                      />
                    </FormControl>
                  )}
                <FormControl mt="10px !important">
                  <Input
                    type="date"
                    label="Date of birth"
                    isInvalid={isAgeInavid}
                    placeholder="DD/MM/YYYY"
                    name="cardNumber"
                    value={dateOfBirth}
                    onChange={(e) =>
                      handleState({ dateOfBirth: e.target.value })
                    }
                  />

                  {isAgeInavid && (
                    <FormHelperText color="red.400">
                      To be able to verify, you need to be within the age
                      bracket from 18-70
                    </FormHelperText>
                  )}
                </FormControl>

                <Button
                  disabled={isDisabled}
                  minH="64px"
                  w="100%"
                  mt="22px"
                  onClick={handleUpload}
                >
                  Continue
                </Button>
              </Box>
            </Box>

            <UploadSuccessModal
              isOpen={isOpen}
              onClose={() => {
                onClose();
                dispatch(resetLevel2Form());
                history.replace("/dashboard/accountVerification");
              }}
            />
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default AccountLevel2Verification;
